<template>
  <div
    class="timeline mb-5"
    :class="{
      light: !isDarkMode,
    }">
    <TimelineRow
      title="Bachelor of Science in Information Technology"
      company="University of Technology Sydney"
      date="2018 - 2022"
      description="Graduated with a major in Enterprise System Development and a minor in Game Development, with a strong focus on UI/UX. Completed two internships as part of the degree."
      icon="graduation-cap"
      :is-content-right="false" />
    <TimelineRow
      title="Full Stack Developer"
      company="Benevolence Financial Group"
      date="2021"
      description="Elevated website structure, implemented new landing pages, and optimised UI/UX for an impactful digital experience. Developed custom loan calculators to help users estimate repayments with ease."
      :is-content-right="true" />
    <TimelineRow
      title="Full Stack Developer"
      company="Spaces Interactive"
      date="2022"
      description="Enhanced error handling and backend security for a seamless React dashboard. Collaborated on defining technical specs for project enhancements."
      :is-content-right="false" />
    <TimelineRow
      title="Full Stack Developer"
      company="Mirk"
      date="2022 - 2023"
      description="Led scoring system development, designed an NFT Marketplace, integrated React with Unity, managed Node backend, enhanced functionalities, implemented Firebase auth, and optimised with TypeScript."
      :is-content-right="true" />
    <TimelineRow
      title="Full Stack Developer"
      company="Quormotion"
      date="2023 - Present"
      description="Develop purpose-driven mobile applications and digital solutions that create meaningful impact. Lead full-stack development of client projects from concept to launch, specialising in cross-platform mobile apps. Collaborate closely with clients to understand their vision and transform ideas into robust, scalable solutions that serve real-world needs. Notable projects include Brain Twist, SMS Sender, managing everything from development to marketing strategy."
      url="https://quormotion.com"
      :is-content-right="false" />
    <!-- <TimelineRow
      title="Mobile Developer"
      company="Freelance Project"
      date="2025"
      description="Developed a custom mobile application for a client to send bulk SMS efficiently. Took time to understand the client's unique needs and delivered a tailored solution that streamlined their communication process. Delivered with attention to detail, usability, and performance."
      :is-content-right="true" /> -->
    <!-- <TimelineRow
      title="Full Stack / Front End Developer"
      company="Seeking New Opportunities"
      date="Present"
      description="Actively seeking new opportunities as a Full Stack or Front End Developer. Skilled in React, Node.js, TypeScript, and other modern technologies. Ready to bring expertise and creativity to a dynamic team."
      :is-content-right="false" /> -->
  </div>
</template>

<script setup lang="ts">
import {ref, watch} from 'vue';
import {useStore} from 'vuex';
import TimelineRow from './TimelineRow.vue';

const store = useStore();
const isDarkMode = ref(store.state.isDarkMode);

watch(
  () => store.state.isDarkMode,
  newValue => {
    isDarkMode.value = newValue;
  },
);
</script>

<style lang="scss" scoped>
.timeline {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    width: 4px;
    background-color: var(--dark-mode-secondary-bg);
    height: 100%;
    transform: translateX(-50%);
  }

  &.light::before {
    background-color: var(--light-mode-secondary-bg);
  }
}

@media (max-width: 768px) {
  .timeline {
    &::before {
      display: none;
    }
  }
}
</style>
